import {
  APIServiceError,
  UnknownAPIServiceResponseError,
} from 'frontcore/data/api-service/service-error/errors/service-error'
import { APIServiceErrorResponse, APIServiceResponse } from 'frontcore/data/api-service/types'
import {
  ServiceCode,
  ServiceCodeErrorMap,
} from 'frontcore/data/api-service/service-error/constants/service-error-code'

const isAPIServiceErrorResponse = <SD>(response: APIServiceResponse): response is APIServiceErrorResponse<SD> => {
  const data = response.data
  if (data == null || typeof data !== 'object') { return false }
  return 'service_code' in data && Number.isInteger(data.service_code)
}

export class APIServiceErrorFactory {
  static build (response: APIServiceResponse): APIServiceError {
    if (isAPIServiceErrorResponse(response)) {
      return this.getServiceError(response)
    }
    return new UnknownAPIServiceResponseError(response)
  }

  private static getServiceError (response: APIServiceErrorResponse<unknown>): APIServiceError {
    const serviceCode: ServiceCode = response.data.service_code
    const error = ServiceCodeErrorMap[serviceCode] ?? UnknownAPIServiceResponseError
    return new error(response)
  }
}
